export default {
  SET_COURSE_INFO: '[sign-up] set course info',
  SET_TRY_INFO: '[sign-up] set try info',
  SET_HAS_BUY: '[sign-up] set has buy',
  SET_PRICE_INFO: '[sign-up] set price info',
  SET_IMAGES: '[sign-up] tab images',
  SET_SCHEDULES: '[sign-up] tab schedules',
  TOGGLE_SCHEDULE_FOLD_STATUS: '[sign-up] toggle fold shedule'
}
